export default {"src":"/_next/static/media/page-not-found.8c851ac3.svg","height":623,"width":746,"blurWidth":0,"blurHeight":0};